import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconSauceLogo } from '@saucelabs/ds-icons';

export const HeaderLogo: FC = () => (
  <Link
    className="flex items-center"
    title="Sauce Labs Dashboard"
    to="/dashboard"
  >
    <IconSauceLogo />
  </Link>
);
